import { Tooltip } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import ButtonItemClass from './ButtonItemClass'
import ButtonItemUl from './ButtonItemUl'

const ButtonSelect = ({ onClick, isSelected, type, data }) => {
  return (
    <div onClick={onClick}>
      {type === 'classes' ? (
        <ButtonItemClass data={data} isSelected={isSelected} />
      ) : (
        <ButtonItemUl data={data} isSelected={isSelected} />
      )}
    </div>
  )
}

export default ButtonSelect
